/*jshint esversion: 6 */
import FbHeader from './FbHeader';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../css/style.css';
import '../css/FbPlugin.css';
import fbScript from '../utils/fbjs.js'
//import IntroLogo from './IntroLogo.js';
//import introText from './texts/intro.txt';

class FbTimelineWide  extends Component {
  constructor(props){
    super(props);
    this.state = {};
  }
    render() {
        console.log('OnlyText props', this.props);
        var header = this.props.header;
        var content = this.props.content;
        var fbLink = encodeURIComponent(this.props.fbLink);
        return ( 
          <div className="column_item fb_wide" >
            <FbHeader
                header = {this.props.header}
                content = {this.props.content}
            />
            <div className="fb_container_width">
                <iframe src={"https://www.facebook.com/plugins/page.php?href="+fbLink+"&tabs=timeline&width=800&height=1500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId"}
                        width="800" 
                        height="1500"  
                        scrolling="yes" 
                        frameborder="0" 
                        allowTransparency="true" 
                        allow="encrypted-media">
                </iframe>
            </div>
          </div>
        );
      }

}

export default FbTimelineWide;


// WEBPACK FOOTER //
// ./src/Templates/FbTimelineWide.js